export const TABS = {
  MAIN: "main",
  SUMMARIES: "summaries",
  // HELP and SETTINGS occupy the same tab position. SETTINGS replaces HELP for users
  // in the verbose_summaries feature flag. HELP will be removed once SETTINGS is fully rolled out.
  HELP: "help",
  SETTINGS: "settings",
}

export const AVAILABILITY_TIMEOUT_ERROR = "AVAILABILITY_TIMEOUT";

// Constants representing different AiMS availability and behavior statuses
export const AIMS_STATUS = {
  // AiMS is available for this meeting, both the organizer and attendees will receive the summary
  AVAILABLE: "AimsAvailable",

  // AiMS is partially available, only the organizer will receive the summary
  SUMMARY_TO_ORGANIZER: "SummaryToOrganizer",

  // AiMS is not available for this meeting (e.g., due to legal policy)
  NOT_AVAILABLE: "AimsNotAvailable",

  // The meeting has external attendee
  EXTERNAL_ATTENDEE: "ExternalAttendee",

  // AiMS failed due to an unexpected error (could be from frontend or backend)
  EXCEPTION: "AimsException",

  // AiMS timed out due to some downstream dependency taking too long (ex - availability lambda taking longer than 30 seconds)
  TIMEOUT: "AimsTimeout",

  // Transcript is available for this meeting
  TRANSCRIPT_AVAILABLE: "TranscriptAvailable",

  // Transcript is not available for this meeting
  TRANSCRIPT_NOT_AVAILABLE: "TranscriptNotAvailable",
};

export const AIMS_NOT_AVAILABLE_MESSAGE = {
  DEFAULT: "Not all meetings are approved for Amazon Meetings Summary.",
  PERFORMANCE: "The meeting subject indicates employee complaints, investigations or performance discussions.",
  REGIONS: "Some attendees are from regions where Amazon Meetings Summary isn't yet available.",
};

export const TRANSCRIPT_NOT_AVAILABLE_MESSAGE = "Some participants are from regions where transcription isn't yet available.";

export const AIMS_AVAILABILITY_MESSAGE_TYPES = {
  WORK_COUNCIL: "work_council",
  PERFORMANCE_REVIEW: "performance_review",
};

export const SUMMARIZATION_START_CHAT_MESSAGE = 'The meeting organizer has enabled AiMS meeting summaries. By participating in this meeting, you understand that Amazon is briefly transcribing and analyzing your voice audio and communications on Zoom to summarize the call.';
export const TRANSCRIPTION_START_CHAT_MESSAGE = `Review Amazon's Recording, Transcription, and Summarization Policy for permitted meeting types.
https://policy.a2z.com/docs/693659/publication

Notify attendees when meetings are being summarized or transcribed.

Meeting organizers are responsible for compliance. Refer to wiki for guidelines.
https://w.amazon.com/bin/view/UnifiedCommunications/MeetingSummaries/AiMS`;

export const ROLES = {
  ORGANIZER: "organizer",
  ALTERNATIVE_HOST: "alternativeHost",
  ATTENDEE: "attendee",
};

export const SUMMARIZE_STATES = {
  DEFAULT: 'default',           // Ready to summarization
  LOADING: 'loading',           // Starting/stopping summarization
  SUMMARIZING: 'summarizing',   // Currently summarizing
  REJECTED: 'rejected',         // Someone else is starting
  STOPPED: 'stopped',           // Summarization stopped
  READY: 'ready'                // Summary is ready
};

export const TRANSCRIPTION_STATES = {
  DEFAULT: 'default',           // Ready to transcription
  LOADING: 'loading',           // Starting/stopping transcription
  TRANSCRIBING: 'transcribing', // Currently transcribing
  REJECTED: 'rejected',         // Someone else is starting
  STOPPED: 'stopped',           // Transcription stopped
};

export const OUTLOOK_WARNINGS = {
  MULTI_MEETING_FOUND_FROM_OUTLOOK: "MultiMeetingFoundFromOutlook",
  MEETING_NOT_FOUND_FROM_OUTLOOK: "MeetingNotFoundFromOutlook"
};

export const RTMS_REQUESTER_DEFAULT_NAME = "Meeting organizer";

// Context constants for modals and components
export const MAIN_CONTEXT = {
  SUMMARIZE: "summarize",
  TRANSCRIBE: "transcribe",
};

// SessionStorage keys for summary pagination
export const SESSION_STORAGE_KEYS = {
  SUMMARY_CACHE: "summaryCache",
  LAST_EVALUATED_KEY: "lastEvaluatedKey",
  RAW_SUMMARIES: "rawSummaries",
  IS_END_OF_DATA: "isEndOfData",
};

// Feature flags
export const FEATURE_FLAGS = {
  ALLOW_SUMMARY_DISTRIBUTION_TOGGLE: true, // Disabled pending legal review on allowing organizers to restrict summary distribution
};

// Autostart modes for transcription
export const AUTO_START_MODES = {
  SINGLE: "single",
  MULTIPLE: "multiple",
};
